import { styled } from "styled-components";

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Row2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;